// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import _ from 'lodash';
// COMPONENTS
import { Fade } from 'react-awesome-reveal';
// ICONS
import { FaCheck } from 'react-icons/fa';
import LoadingScreen from '../../components/LoadingScreen';
import Section from '../../components/Section';
import CustomBlock from '../../components/CustomBlock';
import FormBlock from '../../components/FormBlock';
import ContentBlock from '../../components/ContentBlock';
import SelectBlock from '../../components/SelectBlock';
import ActionBlock from '../../components/ActionBlock';
import Button from '../../components/Button';
import ContentModal from '../../components/ContentModal';
import InputBlock from '../../components/InputBlock';
// SERVICES AND HELPERS
import * as Helper from '../../helpers/helper';
import * as CompanyService from '../../services/company.service';
import * as CategoryService from '../../services/category.service';
import * as QuoteService from '../../services/quote.service';
import QuoteCreateValidator from '../../helpers/validators/sales-management/QuoteCreateValidator';

const QuoteSelectedCategoryPage = (props) => {
    const role = Helper.LoggedInUserRole();
    const companyId = Helper.LoggedInCompanyId();

    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);

    const initialState = {
        id: 0,
        client: "",
        companyId: companyId,
        quoteCategory: []
    }

    const [selectedCompany, setSelectedCompany] = useState(companyId);
    const [companies, setCompanies] = useState([]);
    const [categories, setCategories] = useState([]);
    const [category, setCategory] = useState([]);

    useEffect(() => {
        setLoading(true);
        LoadCompanies(selectedCompany);
    }, [])

    const LoadCompanies = (defaultCompanyId) => {
        if (role == "SuperAdmin") {
            CompanyService.GetAll().then(res => {
                setCompanies(res);
                let companySaved = res.find(x => x.id == defaultCompanyId);
                setSelectedCompany(Helper.SetOptionModel(companySaved.businessName, companySaved.id));
                setLoading(false);
            }).catch(ex => {
                setLoading(false);
            });
        }
        else
            LoadCategories(companyId);
    }

    const LoadCategories = (companyId) => {
        // setLoading(true);
        CategoryService.GetAll(companyId, false).then(res => {
            setCategories(res);
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }

    const LoadCategorySample = (categoryId) => {
        CategoryService.Get(categoryId).then(res => {
            setCategory(res);
            setShow(true);
        }).catch(ex => { });
    }

    const SubmitCategoriesForQuote = (values, setSubmitting) => {
        setLoading(true);
        setSubmitting(true);
        QuoteService.Save(values).then(res => {
            props.history.push("/campaign/" + res);
        }).catch(ex => {
            setLoading(false);
            setSubmitting(false);
        });
    }

    const formik = useFormik({
        initialValues: initialState,
        enableReinitialize: true,
        validationSchema: QuoteCreateValidator,
        onSubmit: (values, { setSubmitting }) => {
            SubmitCategoriesForQuote(values, setSubmitting);
        }
    });

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <FormBlock onSubmit={formik.handleSubmit}>
                                    <Section removeContainer>
                                        {
                                            role == "SuperAdmin" ?
                                                <ContentBlock columnStyle={{ marginBottom: 20 }}>
                                                    <SelectBlock
                                                        id="companyId"
                                                        name="companyId"
                                                        inputLabel="Company"
                                                        bordered
                                                        isSearchable={true}
                                                        value={selectedCompany}
                                                        options={companies.map(x => Helper.SetOptionModel(x.businessName, x.id))}
                                                        onBlur={() => formik.setFieldTouched("companyId")}
                                                        onChange={option => {
                                                            option = option === null ? [] : option;
                                                            formik.setFieldValue("companyId", option.value);
                                                            setSelectedCompany(option);
                                                            LoadCategories(option.value);
                                                        }}
                                                        inputState={
                                                            formik.touched.companyId && formik.errors.companyId
                                                                ? "error"
                                                                : formik.touched.companyId && formik.errors.companyId == null
                                                                    ? "success"
                                                                    : ""
                                                        }
                                                        errorMessage={formik.errors.companyId}
                                                    />
                                                </ContentBlock> : <></>
                                        }

                                        <CustomBlock className="w-100">
                                            {
                                                <>
                                                    {
                                                        selectedCompany == 0 ? <></> :
                                                            <Fade
                                                                triggerOnce
                                                                direction="up"
                                                                duration={600}
                                                                className="w-100"
                                                            >
                                                                <CustomBlock>
                                                                    <InputBlock
                                                                        id="client"
                                                                        name="client"
                                                                        placeholder="Enter Client Name"
                                                                        bordered
                                                                        {...formik.getFieldProps("client")}
                                                                        inputState={
                                                                            selectedCompany == 0 ? "disabled" :
                                                                                formik.touched.client && formik.errors.client
                                                                                    ? "error"
                                                                                    : formik.touched.client && formik.errors.client == null ? "success" : ""
                                                                        }
                                                                        errorMessage={formik.errors.client}
                                                                    // onBlur={(e) => {
                                                                    //     formik.setFieldValue("client", e.target.value);
                                                                    // }}
                                                                    />
                                                                </CustomBlock>
                                                            </Fade>
                                                    }

                                                    <Fade
                                                        triggerOnce
                                                        direction="up"
                                                        duration={600}
                                                        className="w-100"
                                                    >
                                                        {
                                                            categories.map((category, index) =>
                                                                <ActionBlock
                                                                    key={category.id}
                                                                    className="light--bg"
                                                                    title={category.name}
                                                                    actionsPosition="right"
                                                                    primaryActionText="View Sample"
                                                                    primaryActionBackground="info--bg"
                                                                    primaryActionOnClick={() => LoadCategorySample(category.id)}
                                                                    toggleIconPosition="left"
                                                                    toggleIcon={
                                                                        <FaCheck size={20} className={_.find(formik.values.quoteCategory, x => x.categoryId == category.id) != undefined ? "success--clr" : "grey--clr"} />
                                                                    }
                                                                    toggleIconBackground={_.find(formik.values.quoteCategory, x => x.categoryId == category.id) != undefined ? "lighter-green--bg" : "light-grey--bg"}
                                                                    toggleIconOnClick={() => {
                                                                        if (_.find(formik.values.quoteCategory, x => x.categoryId == category.id) != undefined)
                                                                            _.remove(formik.values.quoteCategory, x => x.categoryId == category.id);
                                                                        else
                                                                            formik.setFieldValue("quoteCategory", Array.from(new Set([
                                                                                ...formik.values.quoteCategory,
                                                                                { categoryId: category.id }
                                                                            ])));
                                                                    }}
                                                                />
                                                            )
                                                        }
                                                    </Fade>
                                                </>
                                            }
                                        </CustomBlock>
                                    </Section>
                                    {
                                        selectedCompany == 0 ? <></> :
                                            <Fade
                                                triggerOnce
                                                // direction="up"
                                                duration={400}
                                                delay={1000}
                                                className="w-100"
                                            >
                                                <CustomBlock className="content-container--actions pl-0 pr-0">
                                                    <Button
                                                        text="Start Campaign"
                                                        type="submit"
                                                        className="success--bg w-100 ml-0"
                                                        size="md"
                                                    />
                                                </CustomBlock>
                                            </Fade>
                                    }
                                </FormBlock>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }

            <ContentModal
                size="xl"
                show={show}
                onHide={setShow}
                centered
                contentHeader={category.name}
                contentDescription={category.description}
                primaryVideoHeader="Sample Video"
                primaryVideoUrl={category.videoPath}
                primaryImageHeader="Logo Image"
                primaryImageUrl={category.logoPath}
                secondaryImageHeader="Sample Image"
                secondaryImageUrl={category.imagePath}
            />
        </>

    )
}

export default QuoteSelectedCategoryPage;